const CancellationAndRefund = () => {
    return <div className="px-3">
        <p><span><br /></span><span ><strong>Effective Date:</strong> July 9, 2026</span></p>
        <p><span>The following Cancellation and Refund Policy applies to all inspection orders placed with Inspectiver.</span></p>
        <p><span>This Cancellation and Refund Policy forms part of Inspectiver’s Terms and Conditions and applies to all inspection orders. Mobile inspections require inspector scheduling, coordination with sellers, travel, and administrative work before an inspection begins. The cancellation and service fees below reflect the work completed at each stage of the inspection process.</span></p>
        <p><span>Only one policy condition will apply to each inspection order. If multiple conditions could apply, the most specific applicable condition shall govern.</span></p>
        <p><strong><span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Customer Cancellations</span></strong></p>

        <table className="table table-bordered table-striped">
            <thead className="table-dark">
                <tr>
                    <th>Condition</th>
                    <th>Outcome</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Inspector has not been assigned.</td>
                    <td>A <strong>$30 cancellation fee</strong> will apply. The remaining balance will be refunded to the original payment method.</td>
                </tr>
                <tr>
                    <td>Inspector has been assigned, but the inspection appointment has not yet been scheduled with the seller.</td>
                    <td>A <strong>$50 cancellation fee</strong> will apply. The remaining balance will be refunded to the original payment method.</td>
                </tr>
                <tr>
                    <td>The inspection appointment has been scheduled with the seller.</td>
                    <td>A <strong>$70 cancellation fee</strong> will apply. The remaining balance will be refunded to the original payment method.</td>
                </tr>
                <tr>
                    <td>A cancellation request is received on the scheduled appointment date before the inspector begins traveling to the inspection location, excluding appointments scheduled for the same calendar day the order was placed.</td>
                    <td>A <strong>$90 cancellation fee</strong> will apply. The remaining balance will be refunded to the original payment method.</td>
                </tr>
                <tr>
                    <td>The customer specifically requests a same-day inspection, or the inspection appointment is scheduled for the same calendar day the order was placed.</td>
                    <td><strong>No refund. No rescheduling.</strong></td>
                </tr>
                <tr>
                    <td>The inspection has been completed.</td>
                    <td><strong>No refund.</strong></td>
                </tr>
            </tbody>
        </table>


        <p><strong><span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Seller Cancellations</span></strong></p>

        <table className="table table-bordered table-striped">
            <thead className="table-dark">
                <tr>
                    <th>Condition</th>
                    <th>Outcome</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>The vehicle is unavailable for inspection at the scheduled appointment, including if it has been sold, the seller is unavailable, the seller denies access, the seller refuses to proceed, the vehicle is not present at the scheduled location, or the vehicle cannot reasonably be inspected.</td>
                    <td>A <strong>$110 service fee</strong> will apply. The remaining balance will be refunded to the original payment method</td>
                </tr>
            </tbody>
        </table>

        <p><strong><span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Inspectiver Cancellations</span></strong></p>

        <table className="table table-bordered table-striped">
            <thead className="table-dark">
                <tr>
                    <th>Condition</th>
                    <th>Outcome</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Inspectiver is unable to complete the inspection due to reasons solely within our reasonable control.</td>
                    <td>The customer may choose either a <strong>full refund</strong> or <strong>reschedule the inspection</strong> at no additional cost.</td>
                </tr>
            </tbody>
        </table>

        <p><strong><span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Policy Exceptions</span></strong></p>

        <p><span>Inspectiver reserves the right to issue a full or partial refund outside of this Cancellation and Refund Policy at its sole discretion.</span></p>

        <p><strong><span style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Refunds</span></strong></p>

        <p><span>Approved refunds will be issued to the original payment method. Processing times vary by financial institution and may take several business days before the refund appears on the customer’s account.</span></p>
        <p><span>Refunds will only be issued in accordance with this Cancellation and Refund Policy unless otherwise required by applicable law.</span></p>
        <p><span>This Cancellation and Refund Policy is incorporated into and forms part of Inspectiver’s Terms and Conditions.</span></p>

    </div>
}

export default CancellationAndRefund;